export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12007.0ac0ccd1.jpg";